export default {
  selectedFacility: {},
  selectedCategory: null,
  selectedDate: null,
  comparisonDate: null,
  isComparing: false,
  isAutoCategorized: false,
  selectedApps: []
};
